import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { enterpriseStatusPageAdminRouter } from './tools/enterprise-status-page/routing/EnterpriseStatusPageRouter'
import { enterpriseStatusPageAccessControl } from './tools/enterprise-status-page/access-control/enterpriseStatusPageAccess.configuration'
import ENTERPRISE_STATUS_PAGE_EN_US from './tools/enterprise-status-page/translations/en-US.json'

const EN_US = {
  ...ENTERPRISE_STATUS_PAGE_EN_US,
  // @hygen:inject tool-translations
}

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'enterprise-solutions',
  totem: {
    tool: 'enterprise-solutions-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [enterpriseStatusPageAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-enterprise-status-page',
          labelId: 'enterpriseStatusPageDomain.title',
          accessControl: enterpriseStatusPageAccessControl,
          positionNavV2: 1,
        },
      ],
    },
  ],
}

export default definition
